import styled from 'styled-components';

const Container = styled.div`
    width:100%;
    padding:0rem 12rem;
`;
export default Container;